import { atom, selector } from 'recoil';

export interface AuthUserType {
  isAuthenticated: boolean;
  userProfileModel: {
    userGuid: string;
    email: string;
    firstName: string;
    lastName: string;
    phoneNumber: string;
    status: string;
    userName: string;
    role: string;
    username: string;
    createdOn: string;
    createdBy: string;
    updatedOn: string;
    roleId: number;
    userTypeId: number;
    isSmartPharma: boolean;
    retryCount: number;
    clientIdId: number;
    token: string;
  } | null;
  tokens: {
    accessToken: string;
    refreshToken: string;
    expiresIn: string;
    refreshExpiresIn: string;
  } | null;
  retailerModel: any | null;
  supplierModel: any | null;
  agentModel: any | null;
  role: string;
  username: string;
}

export const authAtom = atom<AuthUserType>({
  key: 'auth',
  default: {
    isAuthenticated: false,
    userProfileModel: null,
    tokens: null,
    retailerModel: null,
    supplierModel: null,
    agentModel: null,
    role: '',
    username: '',
  },
});

export const userSelector = selector<AuthUserType>({
  key: 'userSelector',
  get: ({ get }) => {
    const user = get(authAtom);
    return {
      ...user,
      role: user?.userProfileModel?.role || 'guest',
      username: user?.userProfileModel?.userName || '',
    };
  },
});

export default authAtom;
